<nav *ngIf="hasDashboardPerms" class="navbar navbar-expand-lg navbar-dark">
  <div class="brand-title"><img src="../../../assets/mercury.jpeg" height="40"/></div>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>

  <div class="menu-container collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav">
      <!-- Dashboard -->
      <li routerLinkActive="active-nav-item">
        <a routerLink="/dashboard"><span class="fa fa-home"></span> Dashboard</a>
      </li>

      <!-- View / Maintain -->
      <li *ngIf="isMaintainAuthed" class="nav-item dropdown">
        <a routerLinkActive="active"
        class="nav-link dropdown-toggle selectable"
        role="button"
        data-bs-toggle="dropdown"
        aria-expanded="false">
          <span class="fa fa-cog"></span>
          View/Maintain
          <span class="caret"></span>
        </a>
        <ul class="dropdown-menu" style="max-width: 500px; width: calc(100vw - 24px); background-color: #63a356; color: white; padding: 12px;" >
        <div class="row" >
          <li class="col-md-4 navOption">
            <h6 *ngIf="isAlgorithmAuthed"><span class="fa fa-list-alt"></span>Algorithm</h6>
            <ul class="list-unstyled">
                <li class="selectable" *ngIf="hasAlgorithmPerms" routerLinkActive="active"><a routerLink="/config/algorithm/managealgorithm">Algorithms</a></li>
                <li class="selectable" *ngIf="hasAlgorithmEnableDisablePerms" routerLinkActive="active"><a routerLink="/config/algorithm/enabledisable">Enable/Disable</a></li>
            </ul><br>
            <h6 *ngIf="isNotificationAuthed"><span class="fa fa-bell"></span>Notifications</h6>
            <ul class="list-unstyled">
              <li class="selectable" *ngIf="hasNotificationRulesPerms" routerLinkActive="active"><a routerLink="/config/notification/rules">Rules</a></li>
              <li class="selectable" *ngIf="hasNotificationTemplatePerms" routerLinkActive="active"><a routerLink="/config/notification/notificationtemplates">Templates</a></li>
              <li class="selectable" *ngIf="hasTemplateLocalePerms" routerLinkActive="active"><a routerLink="/config/notification/notificationtemplatelocales">Template Locales</a></li>
            </ul>
          </li>
          <li class="col-md-4 navOption">
            <h6 *ngIf="isAccessControlAuthed"><span class="fa fa-users"></span> Access Control</h6>
            <ul class="list-unstyled">
              <li class="selectable" *ngIf="hasRolePerms" routerLinkActive="active"><a routerLink="/config/acl/roles">Roles</a></li>
              <li class="selectable" *ngIf="hasUserPerms" routerLinkActive="active"><a routerLink="/config/acl/users">Users</a></li>
              <li class="selectable" *ngIf="hasScreenPerms" routerLinkActive="active"><a routerLink="/config/acl/screens" >Screens</a></li>
              <li class="selectable" *ngIf="hasScreenRightGroupPerms" routerLinkActive="active"><a routerLink="/config/acl/screenrightgroups">Screen Rights</a></li>
              <li class="selectable" *ngIf="hasRoleToScreenPerms" routerLinkActive="active"><a routerLink="/config/acl/roletoscreens">Role to Screens</a></li>
            </ul>
          </li>
          <li class="col-md-4 navOption">
            <h6 *ngIf="isSystemAuthed"><span class="fa fa-laptop-code"></span> System</h6>
            <ul class="list-unstyled">
              <li class="selectable" *ngIf="hasProductFamilyPerms" routerLinkActive="active"><a routerLink="config/product/families">Product Families</a></li>
              <li class="selectable" *ngIf="hasProductLinePerms" routerLinkActive="active"><a routerLink="config/product/lines">Product Lines</a></li>
              <li class="selectable" *ngIf="hasMasterDataPerms" routerLinkActive="active"><a routerLink="config/system/masterdata">Master Data Config</a></li>
              <li class="selectable" *ngIf="hasServiceContractPerms" routerLinkActive="active"><a routerLink="config/system/servicecontracts">Service Contracts</a></li>
              <li class="selectable" *ngIf="hasExclusionsPerms" routerLinkActive="active"><a routerLink="config/system/exclusions">Exclusions</a></li>
              <li class="selectable" *ngIf="hasServiceContractOverridesPerms" routerLinkActive="active"><a routerLink="config/system/servicecontractoverrides">Service Contract Overridess</a></li>
            </ul>
        </li>
        </div>
        </ul>
      </li>
      <!-- <li class="right-aligned">
        <a><span class="fa fa-question-circle"></span> Help </a>
      </li> -->
      <li class="dropdown right-aligned">
        <a class="nav-link">
          <span class="fa fa-user"></span> {{userName}}
        </a>
      </li>
    </ul>
  </div>
</nav>
